module.exports = __webpack_public_path__ + "img/right1.8e57b0a9.svg";